module.exports = __webpack_public_path__ + "static/media/savio26.3c162b4b.jpg";